var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBookImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 123,
    viewBox: "0 0 140 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_797_25553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.915 18.7156L127.62 122.163L60.2971 114.161L50.1695 112.958L47.8845 112.686L47.7271 112.668L48.107 109.476L48.437 106.711L54.517 55.5306L59.7045 11.8806L60.0196 9.22305L80.7095 11.6806L139.915 18.7156Z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.05 95.2256C105.887 95.2256 105.737 95.1181 105.69 94.9531L82.2947 12.3456C82.2372 12.1456 82.3547 11.9381 82.5522 11.8831C82.7522 11.8256 82.9597 11.9431 83.0147 12.1406L106.412 94.7481C106.47 94.9481 106.352 95.1556 106.155 95.2106C106.117 95.2206 106.085 95.2256 106.05 95.2256Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.602 103.866L55.8972 113.263L50.1697 112.576L50.4147 109.691L54.5172 54.9831L57.8297 10.8256L59.8547 9.89557L82.6572 12.2431L106.602 103.866Z",
    fill: "#1D232A",
    stroke: "#1D232A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6171 7.18764e-05L0.0849609 17.499L22.743 119.184L101.275 101.685L78.6171 7.18764e-05Z",
    fill: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.927 34.1081C15.7545 34.1081 15.5995 33.9881 15.562 33.8156C15.517 33.6131 15.6445 33.4131 15.847 33.3681L71.0794 21.0581C71.2819 21.0106 71.4819 21.1406 71.5269 21.3431C71.5719 21.5456 71.4444 21.7456 71.2419 21.7906L16.0095 34.1006C15.982 34.1056 15.9545 34.1081 15.927 34.1081Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5173 50.2156C19.3448 50.2156 19.1898 50.0956 19.1523 49.9231C19.1073 49.7206 19.2348 49.5206 19.4373 49.4756L74.6698 37.1656C74.8698 37.1181 75.0723 37.2481 75.1173 37.4506C75.1623 37.6531 75.0348 37.8531 74.8323 37.8981L19.5998 50.2056C19.5723 50.2106 19.5448 50.2156 19.5173 50.2156Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1072 66.3206C22.9347 66.3206 22.7797 66.2006 22.7422 66.0281C22.6972 65.8256 22.8247 65.6256 23.0272 65.5806L78.2597 53.2706C78.4622 53.2256 78.6622 53.3531 78.7072 53.5556C78.7522 53.7581 78.6247 53.9581 78.4222 54.0031L23.1897 66.3106C23.1622 66.3156 23.1347 66.3206 23.1072 66.3206Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.697 82.4256C26.5245 82.4256 26.3695 82.3081 26.332 82.1331C26.287 81.9306 26.4145 81.7306 26.617 81.6856L81.8496 69.3755C82.0521 69.3305 82.2521 69.458 82.2971 69.6605C82.3421 69.863 82.2146 70.063 82.0121 70.108L26.7795 82.4181C26.7495 82.4231 26.722 82.4256 26.697 82.4256Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2847 98.5306C30.1122 98.5306 29.9572 98.4131 29.9197 98.2381C29.8747 98.0356 30.0022 97.8356 30.2047 97.7906L69.1797 89.103C69.3797 89.058 69.5822 89.1855 69.6272 89.388C69.6722 89.5905 69.5447 89.7905 69.3422 89.8355L30.3672 98.5231C30.3397 98.5281 30.3122 98.5306 30.2847 98.5306Z",
    fill: "#1D232A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_797_25553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139.83,
    height: 122.163,
    fill: "white",
    transform: "translate(0.0849609 9.15527e-05)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBookImage);
export default __webpack_public_path__ + "static/media/emptyBookImage.f973af4e0870b0f9f41083a170dd32ac.svg";
export { ForwardRef as ReactComponent };